import { GAMES_PLAYER_RELEVANCE } from "@/app/constants.mjs";
import type { GameSearchProps } from "@/search/types.mjs";
import symbolName from "@/util/symbol-name.mjs";

// This is just a string rather than a symbol because we wanna put it in history state.
export const IS_SEARCH_ACTIVE = "isSearchActive";

export const PLAYER_SEARCH_DEBOUNCE_INTERVAL = 400;

export const SEARCH_QUERY: unique symbol = symbolName("omni-search-query");

// case sensitive, remove special characters
export const SEARCH_ENCODER = (s: string) =>
  s.replace(/[^0-9\p{L}#_\s]/gu, "").toLocaleLowerCase();

// Extend router state to properly type the `SEARCH_QUERY` symbol
declare module "@/__main__/router.mjs" {
  export interface RouteStateExt {
    [SEARCH_QUERY]?: GameSearchProps;
  }
}

// Extend router state to properly type the `shouldShowGlobalSearch` boolean
declare module "@/__main__/app-state.mjs" {
  interface VolatileState {
    shouldShowGlobalSearch?: boolean;
    globalSearchQuery?: string;
  }
}

export const CACHE_KEY = "⚡omni-search-cache"; // must be string for fuzzysort
export const NO_CATEGORY = Object.assign(["search:noCategory", "Other"], {
  symbol: "⚡no-category", // must be string to preserve insert order
});

export const DEFAULT_SEARCH_PLACEHOLDER: Translation = [
  "search.placeholder",
  "Search profiles, characters, weapons, tier lists, and more!",
];

export const GAME_SEARCH_COEFFICIENTS = GAMES_PLAYER_RELEVANCE.reduce(
  (acc, curr, i) => {
    acc[curr] = i + 1;
    return acc;
  },
  {},
);
